<script lang="ts">
import type { PopoverContentEmits, PopoverContentProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

export type ComboboxContentProps = PopoverContentProps & {
  class?: HTMLAttributes['class']
  disabled?: boolean
}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import { useForwardPropsEmits } from 'reka-ui'
import { useFloatingZ } from '#ui-kit/lib/useFloatingZ'
import { cn } from '#ui-kit/lib/utils'
import { Command } from '#ui-kit/ui/command'
import { PopoverContent } from '#ui-kit/ui/popover'

const props = withDefaults(defineProps<ComboboxContentProps>(), {
  sideOffset: 4,
  align: 'start',
})
const emits = defineEmits<PopoverContentEmits>()

const popoverProps = reactiveOmit(props, 'class', 'disabled')
const forwarded = useForwardPropsEmits(popoverProps, emits)
const floatingZ = useFloatingZ()
</script>

<template>
  <PopoverContent
    v-bind="forwarded"
    :class="cn('p-0 w-(--reka-popper-anchor-width) min-w-32 max-h-96 overflow-hidden font-sans', props.class)"
    :style="{ zIndex: floatingZ }"
  >
    <Command highlight-on-hover :disabled="disabled">
      <slot />
    </Command>
  </PopoverContent>
</template>
